
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">All Projects</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">All Projects</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [searchHelp]="searchHelp" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div style="display: inline-flex; line-height: 12px; padding-top: 0.5rem;"><span class="btn btn-primary btn-circle-sm oi oi-info" style="margin-right: 0.5rem; margin-top: -2px;"></span>
        <p style="background-color: inherit;">Please provide search criteria to view projects list. (By default all projects will not be loaded.)</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 pb-2">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" autoLinkToLabel [(ngModel)]="includeMpcProjects" (change)="refreshBrowser()">
        <label class="form-check-label form-check-filter">Include MPC Projects</label>
      </div>
    </div>
    <div class="pb-2" style="margin: 0px 15px;width: 194px;">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" autoLinkToLabel [(ngModel)]="onlyMpcProjects" (change)="refreshBrowser()">
        <label class="form-check-label form-check-filter">Show MPC Projects Only</label>
      </div>
    </div>
    <div class="col-md-3 pb-2">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" autoLinkToLabel [(ngModel)]="closedProjects" (change)="refreshBrowser()">
        <label class="form-check-label form-check-filter">Show Closed Projects</label>
      </div>
    </div>
    <div class="col-md-4">
      <div style="margin-right: -62px" *ngIf="type==&quot;&quot;">
        <button class="btn btn-primary float-right mt-7 dropdown-toggle" type="button" data-toggle="dropdown">Sort By
          <div class="dropdown-menu dropdown-menu-left"><a class="dropdown-item" (click)="showAddSortButton('createdAt')">Created date </a><a class="dropdown-item" (click)="showAddSortButton('updatedAt')">Updated date</a><a class="dropdown-item" (click)="showAddSortButton('name')">Project Name  </a></div>
        </button>
      </div>
      <div style="margin-right: -62px" *ngIf="type!=&quot;&quot;">
        <button class="btn btn-primary float-right mt-7 dropdown-toggle" type="button" data-toggle="dropdown">SortBy : {{type}} 
          <div class="dropdown-menu dropdown-menu-left"><a class="dropdown-item" (click)="showAddSortButton('createdAt')">Created date </a><a class="dropdown-item" (click)="showAddSortButton('updatedAt')">Updated date</a><a class="dropdown-item" (click)="showAddSortButton('name')">Project Name </a></div>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col" *ngIf="!loading">
      <div class="row" *ngFor="let project of projects">
        <div class="col">
          <div class="card-item">
            <div class="card-progress-bar float-right">
              <div class="progress">
                <div class="progress-bar" role="progressbar" title="{{ project.deployedPercentageBar?.title }}" [ngClass]="project.deployedPercentageBar?.type" [style.width]="project.deployedPercentageBar?.width + '%'">{{project.deployedPercentageBar?.value + "%"}}</div>
              </div>
            </div>
            <h4>{{ project.name }}<span class="badge ml-1" *ngIf="project.rejected" [ngClass]="{'badge-warning': true}">Rejected</span></h4>
            <property-container *ngIf="project.isCurrentUserOnProject">
              <property-item><a [routerLink]="['/project']" [queryParams]="{id: project.id}">Details</a></property-item>
              <property-item [showIf]="(isPurgeMasterRole || project.status != 'archived')"><a [routerLink]="['/workflow', project.workflowId]">Set Up Project &amp; Add Devices</a></property-item>
              <property-item [showIf]="!daasTargetSytemList.includes(project.targetSystem)"><a [routerLink]="['/dashboard']" [queryParams]="{projectId: project.id}">Dashboard</a></property-item>
            </property-container>
            <property-container *ngIf="project.isCurrentUserOnProject &amp;&amp; !daasTargetSytemList.includes(project.targetSystem)">
              <property-item [showIf]="(isPurgeMasterRole || project.status != 'archived')"><a [routerLink]="['/sites']" [queryParams]="{projectId: project.id}">{{ project.siteCount || 0 }} site(s)</a></property-item>
              <property-item [showIf]="(isPurgeMasterRole || project.status != 'archived')"><a [routerLink]="['/orders']" [queryParams]="{projectId: project.id}">{{ project.orderCount || 0 }} order(s)</a></property-item>
              <property-item [showIf]="(isPurgeMasterRole || project.status != 'archived')"><a [routerLink]="['/deployments']" [queryParams]="{projectId: project.id}">{{ project.deploymentCount || 0 }} deployments(s)</a></property-item>
            </property-container>
            <property-container *ngIf="!project.isCurrentUserOnProject &amp;&amp; !daasTargetSytemList.includes(project.targetSystem)">
              <property-item>{{ project.siteCount || 0 }} site(s)</property-item>
              <property-item>{{ project.orderCount || 0 }} order(s)</property-item>
              <property-item>{{ project.deploymentCount || 0 }} deployments(s)</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.countryName">{{ project.countryName }}</property-item>
              <property-item [showIf]="project.csa">CSSA: {{ project.csa || 'none' }}</property-item>
              <property-item [showIf]="project.ampId">AMP: {{ project.ampId || 'none' }}</property-item>
              <property-item [showIf]="project.geoRegionId == 'EMEA'">MS ID: {{ project.msId || 'none' }}</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.startDate">Start Date: {{ project.startDate | date: 'yyyy-MM-dd'}}</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.estimatedCompletionDate &amp;&amp; !daasTargetSytemList.includes(project.targetSystem)">Estimated Completion Date: {{ project.estimatedCompletionDate | date: 'yyyy-MM-dd'}}</property-item>
            </property-container>
            <property-container *ngIf="false">
              <property-item [showIf]="!daasTargetSytemList.includes(project.targetSystem)">{{ project.deployedDevices | number:0 }} device(s) deployed</property-item>
              <property-item [showIf]="!daasTargetSytemList.includes(project.targetSystem)">{{ project.plannedDevices | number:0 }} device(s) planned</property-item>
              <property-item>{{ project.totalDevices | number:0 }} total devices</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.transitionLeads?.length"><span>Transition Leads: </span>
                <ng-template ngFor let-person [ngForOf]="project.transitionLeads" let-isFirst="first">
                  <ng-template [ngIf]="!isFirst">, </ng-template><a [href]="'mailto:' + person.emailAddress">{{ person.firstName }} {{ person.lastName }}</a>
                </ng-template>
              </property-item>
            </property-container>
            <property-container class="red">
              <property-item [showIf]="project.overBudget"><span class="oi oi-dollar"></span> {{ project.overBudgetMessage }}</property-item>
            </property-container>
            <property-container class="red">
              <property-item [showIf]="project.pastSchedule"><span class="oi oi-clock"></span> {{ project.pastScheduleMessage }}</property-item>
            </property-container>
            <div class="row">
              <div class="col">
                <div class="btn-group float-right button-box">
                  <button class="btn btn-outline-success" type="button" *ngIf="!project.isCurrentUserOnProject" (click)="assignMeToProject(project.id)">Assign Me to Project</button>
                  <button class="btn btn-outline-dark" type="button" *ngIf="project.isCurrentUserOnProject" (click)="unassignMeToProject(project.id)">Remove Me From Project</button>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div *ngIf="loading">     
        <md-spinner-block></md-spinner-block>
      </div>
    </div>
  </div>
</div>